<template>
    <div style="    position: relative;">
        <b-form-input :id="idFor" :type="passwordType" v-model="inputValue" required @input="updateData">

        </b-form-input>
        <b-btn @click="toggleShow" class="show-password-btn">
            <eye-icon class="icon-default eye-icon">
            </eye-icon>
        </b-btn>

    </div>

</template>

<script>
import EyeIcon from '../../assets/eye.svg';
export default {
  name: 'PasswordInput',
  props: ['idFor', 'value'],
  components: {
    EyeIcon
  },
  data() {
    return {
      passwordType: 'password',
      inputValue: ''
    };
  },
  created() {
    this.inputValue = this.value;
  },
  methods: {
    updateData() {
      this.$emit('input', this.inputValue);
    },
    toggleShow() {
      if (this.passwordType == 'text') {
        this.passwordType = 'password';
        return;
      }
      this.passwordType = 'text';
    }
  }
};
</script>

<style scoped>
.btn {
  position: absolute;
  top: 4px;
  right: 4px;
  background: none !important;
  border: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Common/PasswordInput.vue